import React from 'react';
import AppProvidersShell from './app/AppProvidersShell';
import AppRoutesGate from './AppRoutesGate';

function App() {
  return (
    <AppProvidersShell>
      <AppRoutesGate />
    </AppProvidersShell>
  );
}

export default App;
